var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 44,
    viewBox: "0 0 47 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61001 19.8099L0.880014 9.88991C0.445811 9.14159 0.163445 8.31499 0.0490771 7.45742C-0.0652905 6.59984 -0.00941157 5.72813 0.21351 4.89218C0.436431 4.05622 0.822021 3.27244 1.34821 2.58568C1.8744 1.89892 2.53086 1.32267 3.28001 0.889913H3.35001C4.86198 0.0156847 6.65914 -0.2226 8.34668 0.227411C10.0342 0.677422 11.4741 1.77892 12.35 3.28992L29.58 33.1299C30.0121 33.8798 30.2922 34.7074 30.4044 35.5655C30.5166 36.4236 30.4587 37.2954 30.234 38.1311C30.0093 38.9668 29.6221 39.7501 29.0947 40.4362C28.5673 41.1224 27.9099 41.6979 27.16 42.1299H27.09C25.5762 43.0006 23.7791 43.2359 22.0922 42.7842C20.4053 42.3324 18.9661 41.2306 18.09 39.7199L6.61001 19.8099ZM38.11 0.00991239C39.7457 0.00991239 41.3446 0.494942 42.7046 1.40366C44.0646 2.31238 45.1246 3.60398 45.7505 5.11512C46.3764 6.62627 46.5402 8.28909 46.2211 9.89331C45.902 11.4975 45.1144 12.9711 43.9578 14.1277C42.8012 15.2843 41.3276 16.0719 39.7234 16.391C38.1192 16.7101 36.4564 16.5463 34.9452 15.9204C33.4341 15.2945 32.1425 14.2345 31.2338 12.8745C30.325 11.5145 29.84 9.91556 29.84 8.27991C29.84 6.08657 30.7113 3.98307 32.2622 2.43214C33.8132 0.881216 35.9167 0.00991239 38.11 0.00991239Z",
    fill: "#0071EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.538c7b12db1846eb23c22ac668c3fc2f.svg";
export { ForwardRef as ReactComponent };